module.exports = __webpack_public_path__ + "img/excel_ico.b6b08447.png";